import React, { useEffect } from 'react';
import { useTable } from 'react-table'
import { useFilters, useFlexLayout, useGlobalFilter, usePagination, useSortBy } from 'react-table/dist/react-table.development';
import { range } from '../../Utils/functions';
import './Table.scss'
import Dropdown from '../Dropdown/Dropdown'
import axios from 'axios';

const Table = ({columns, onRowClick, url }) => {
  const [ sorted, setSorted ] = React.useState('');
  const [ sortedDesc, setSortedDesc ] = React.useState(true)
  const [ filter, setFilter ] = React.useState({})
  const [ filterKey, setFilterKey ] = React.useState('')
  const [ currentPage, setCurrentPage ] = React.useState(0)
  const [ list, setList ] = React.useState([])
  const [ count, setCount ] = React.useState(0)
  const [ page, setPage ] = React.useState(1)

  let data = React.useMemo(
    () => list,
    [list]
  )

  useEffect(() => {
    getHistorys()
  },[page])

  const getHistorys = () => {
    axios.get(url + `?query=&limit=5&ascending=1&page=${page}&byColumn=0`)
    .then((data) => {
      setList(data.data.data)
      setCount(data.data.count)
    })
  }

  function renderFilter(column) {
    return (
      <div className='input-wrap'>
        <input
          className='custom-input'
          value={filter[column.id]}
          onChange={e => {
            setFilter({ key : e.target.value})
          }}
          onFocus={e => {setFilterKey(column.id); setSorted(column.id)}}
          placeholder={column.Header}
        />
        <img src={require('../../aseets/icons/search.svg').default} style={{ width : 24, height : 24, position : 'absolute', top : 12, right : 16 }} />
      </div>
    )
  }

  const renderSort = (column) => {
    if( column.isDropdown === true ){
      return(
        <div>
          <Dropdown key={column.id} width={column.width} options={column.options} value={sorted} defaultTitle={column.Header} selected={sorted === column.id} onItemClick={(value) => {setSorted(column.id); setSortedDesc(!sortedDesc);}}/>
        </div>
      )
    }else{
      return(
        <div className={`sort ${ sorted === column.id ? 'selected' : '' }`} onClick={() => {{setSorted(column.id); setSortedDesc(!sortedDesc);}}}>
          <p>{column.Header}</p>
          <p>
          {
            column.id === sorted
            ? sortedDesc
              ? <img src={require('../../aseets/icons/sort-down.svg').default} style={{ width : 24, height : 24, marginTop : 6 }} />
              : <img src={require('../../aseets/icons/sort-up.svg').default} style={{ width : 24, height : 24, marginTop : 6 }} />
            : <img src={require('../../aseets/icons/sort.svg').default} style={{ width : 24, height : 24, marginTop : 6 }} />
          }
          </p>
        </div>
      )
    }
  }
 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize
  } = useTable({ columns, data, manualSortBy : true, manualFilters : true, initialState : { filter, pageIndex : 0, pageSize : 5 } },useFilters,useSortBy, usePagination, useFlexLayout)

  React.useEffect(() => {
    setFilter(state.filters);
  }, [state, setFilter]);

  const renderPagiantion = () => {
    if(rows.length > 0){
      return(
        <div className='footer'>
          <div className="pagination">
            <button onClick={() => {setPage(1); setCurrentPage(0)}} disabled={page === 1} style={{marginRight : 16}}>
              {'<<'}
            </button>{' '}
            <button onClick={() => {setCurrentPage(currentPage-10); setPage(currentPage - 9);}} disabled={currentPage < 10} style={{ marginRight : 14 }}>
              {'<'}
            </button>{' '}
            <div className='page-list'>
              {
                range((parseInt(currentPage / 10) * 10 ) + 1,(((currentPage / 10) * 10 ) + 10 > parseInt(count/5) ? (parseInt(count/5) + (count%5 === 0 ? 0 : 1)) : ((currentPage / 10) * 10 ) + 10)  ).map((data,i) => {
                  return(
                    <span key={i} onClick={() => {setPage(data);}} className={`${page === data ? 'selected-page' : 'page-item'}`}><p>{data}</p></span>
                  )
                })
              }
            </div>
            <button onClick={() => {setCurrentPage(currentPage+10);setPage(currentPage + 11)}} disabled={((currentPage+10)/10 ) >= parseInt(count/5)/10} style={{ marginLeft : 14 }}>
              {'>'}
            </button>{' '}
            <button onClick={() => {setPage(Math.ceil(count/5)); setCurrentPage(parseInt((count/5)/10)*10);}} disabled={(page >= Math.ceil(count/5))} style={{ marginLeft : 16 }}>
              {'>>'}
            </button>{' '}
          </div>
        </div>
      )
    }
  }

  return (
    <div style={{ display : 'flex', flexDirection : 'column'}} className='table-comp'>
      <table {...getTableProps()}>
          {/* <thead>
          { headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              { headerGroup.headers.map((column,i) => {
                return(
                  <th {...column.getHeaderProps(column.getSortByToggleProps())} className={ i === 0 ? 'start' : i === headerGroup.headers.length - 1  ? 'end' : ''}>
                    <div className={ column.canFilter ? '' : ''}>
                      <div key={column}>{column.canFilter ? renderFilter(column) : column.canSort ? renderSort(column) : ''}
                      </div>
                    </div>
                  </th>
              )})}
            </tr>
          ))}
          </thead> */}
          <thead>
          { headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              { headerGroup.headers.map((column,i) => {
                return(
                  <th {...column.getHeaderProps(column.getSortByToggleProps())} className={ i === 0 ? 'start' : i === headerGroup.headers.length - 1  ? 'end' : ''}>
                    <p className='column-title'>{column.Header}</p>
                  </th>
              )})}
            </tr>
          ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            { rows.length === 0 ?
              <tr style={{ display:'flex',alignItems:'center', justifyContent:'center'}}><td><p className='empty-list'>내역이 없습니다.</p></td></tr>
              : null}
          {
            rows.map(row => {
              prepareRow(row)
              return (
              <tr {...row.getRowProps()} className="table-row" onClick={ () => { if(typeof onRowClick !== 'undefined') onRowClick(row.original);}}>
                { row.cells.map((cell,i) => {
                return (
                    <td {...cell.getCellProps([{style : cell.column.style}])} className={ i === 0 ? 'row' : i === row.cells.length - 1  ? 'end' : ''}>
                    { cell.render('Cell') }
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <td>
              {renderPagiantion()}
            </td>
          </tr>
        </tfoot>
      </table>
      
    </div>
  )
}

export default Table